import React from 'react';
import { blogPosts } from '../content/blogPosts';
import './LearnPage.css';
import ArticleContent from '../components/ArticleContent';
import { articleHeadingId } from '../content/learnMetadata';

function PostDate({ date }) {
  const label = new Intl.DateTimeFormat('en-US', {
    month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC',
  }).format(new Date(`${date}T00:00:00Z`));
  return <time dateTime={date}>{label}</time>;
}

export default function LearnPage({ post }) {
  return (
    <main className="learn-page" id="top">
      <div className="learn-page__inner">
        {post ? (
          <article>
            <a className="learn-page__back" href="/learn/">← All posts</a>
            <p className="learn-page__eyebrow">{post.category} · <PostDate date={post.publishedAt} /></p>
            <h1>{post.title}</h1>
            <details className="learn-article__contents">
              <summary>In this article</summary>
              <nav aria-label="Article contents">
                {post.blocks.filter((block) => block.type === 'h2').map((block) => (
                  <a href={`#${articleHeadingId(block.text)}`} key={block.text}>{block.text}</a>
                ))}
              </nav>
            </details>
            <div className="learn-article__body">
              <ArticleContent blocks={post.blocks} />
            </div>
            <aside className="learn-article__related" aria-label="Related reading">
              <h2>Keep learning</h2>
              {blogPosts.filter((entry) => entry.slug !== post.slug).map((entry) => (
                <a href={`/learn/${entry.slug}/`} key={entry.slug}>{entry.title} →</a>
              ))}
            </aside>
            <a className="learn-page__back learn-page__back--bottom" href="/learn/">← Explore all posts</a>
          </article>
        ) : (
          <>
            <header className="learn-page__heading">
              <h1>Learn About Breathwork.</h1>
              <p className="learn-page__intro">Explore the science of breathing and the practice of better performance.</p>
            </header>
            <div className="learn-posts">
              {blogPosts.map((entry) => (
                <a className="learn-post" href={`/learn/${entry.slug}/`} key={entry.slug}>
                  <div>
                    <p className="learn-page__eyebrow">{entry.category} · <PostDate date={entry.publishedAt} /></p>
                    <h2>{entry.title}</h2>
                    <p className="learn-post__summary">{entry.summary}</p>
                  </div>
                  <span className="learn-post__icon" aria-hidden="true">↗</span>
                </a>
              ))}
            </div>
          </>
        )}
      </div>
    </main>
  );
}
